import React from 'react'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import {useIntl, FormattedMessage} from 'react-intl'
import {useBrand} from '../../contexts/brand-context'

export const TermsAndConditionsLabel = () => {
    const {isGarage} = useBrand()
    const {formatMessage} = useIntl()

    const getTermsAndConditionsMessage = () => (
        <Link
            href="/terms-conditions.html"
            target="_blank"
            rel="noopener noreferrer"
            textDecoration={'underline'}
        >
            <FormattedMessage id="terms.and.conditions" defaultMessage="Terms & Conditions" />
        </Link>
    )

    const getPrivacyPolicyMessage = () => (
        <Link
            href="/privacy-policy.html"
            target="_blank"
            rel="noopener noreferrer"
            textDecoration={'underline'}
        >
            <FormattedMessage id="privacy.policy" defaultMessage="Privacy Policy" />
        </Link>
    )

    return (
        <Text fontSize="xs" lineHeight="1.5">
            {isGarage
                ? formatMessage(
                      {
                          defaultMessage:
                              'I confirm that I am 16 years or older and acknowledge the {termsLink} and {privacyLink}.',
                          id: 'use_registration_fields.label.terms_and_conditions.garage'
                      },
                      {
                          termsLink: getTermsAndConditionsMessage(),
                          privacyLink: getPrivacyPolicyMessage()
                      }
                  )
                : formatMessage(
                      {
                          defaultMessage:
                              'I confirm that I am 16 years or older and acknowledge the {termsLink} and {privacyLink}.',
                          id: 'use_registration_fields.label.terms_and_conditions.dynamite'
                      },
                      {
                          termsLink: getTermsAndConditionsMessage(),
                          privacyLink: getPrivacyPolicyMessage()
                      }
                  )}
        </Text>
    )
}
